import Modal from '../../../shared/Modal';
import CreateAccountForm from '../../contact/CreateAccountForm';

const ProfileModal = ({
  open,
  setOpen,
  closeActive,
  isCreated,
  currentUser,
  permission,
  logout,
  losesAccess,
  setCloseActive,
  message,
  updateUser,
}) => {
  return (
    <Modal isOpen={open} onClose={() => setOpen(false)} title="Perfil" closeActive={closeActive}>
      {(close) => (
        <div className="p-8 mt-8 mb-8">
          <CreateAccountForm
            onBackToLogin={updateUser}
            mode={isCreated ? 'create' : 'view'}
            userlogin={isCreated ? null : currentUser}
            onClose={close}
            permissions={permission}
            logout={logout}
            losesAccess={losesAccess}
            closeActive={setCloseActive}
            message={message}
          />
        </div>
      )}
    </Modal>
  );
};

export default ProfileModal;
